import styled from 'styled-components';

export const FooterLoginStyle = styled.footer`
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => {
    return theme.colors.black;
  }};

  img {
    width: 50px;
  }

  span {
    font-size: ${({ theme }) => {
      return theme.fonts.size.big;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    color: ${({ theme }) => {
      return theme.colors.white;
    }};
    margin-left: 30px;
  }
`;
